import { render, staticRenderFns } from "./TqCopy.vue?vue&type=template&id=3cac992a&scoped=true&"
import script from "./TqCopy.vue?vue&type=script&lang=js&"
export * from "./TqCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac992a",
  null
  
)

export default component.exports